import { PropsWithChildren } from 'react';
import clsx from 'clsx';
import OopsSvg from '@/assets/icons/oops.svg';
import { IWithClassname } from '@/models/common';
import s from './NoResults.module.scss';

interface Props extends IWithClassname, PropsWithChildren {
  noTitle?: boolean;
}

export const NoResults = ({ className, noTitle, children }: Props) => {
  return (
    <div className={clsx(s.wrapper, className)}>
      {!noTitle && <span className={s.wrapper__title}>Ничего не найдено</span>}
      <div className={s.wrapper__children}>{children}</div>
      <OopsSvg className={s.wrapper__image} />
    </div>
  );
};